import Image from 'next/image'
import { memo } from 'react'

import generateBlurDataURL from '@/helpers/generateBlurDataURL'

function Cover({ name, src }: CoverProps) {
  const blur = generateBlurDataURL(160, 128)

  return (
    <figure className="relative flex-shrink-0 w-16 h-20 overflow-hidden rounded-lg sm:w-32 sm:h-40">
      {src && (
        <Image
          alt={name}
          src={src}
          layout="fill"
          objectFit="cover"
          placeholder="blur"
          blurDataURL={blur}
          priority
          quality={75}
          loading="eager"
        />
      )}
    </figure>
  )
}

interface CoverProps {
  name: string
  src: string
}

export default memo(Cover)
